import request from '@/utils/request'
// ------------------新闻---------------
// 分页获取视频课程列表
export function listNews(query) {
  return request({
    url: '/web/news',
    method: 'get',
    params: query
  })
}


// WEBPACK FOOTER //
// ./src/api/news.js